<template>
	<div class="container">
		<div class="header-title" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
			预约结果
		</div>
		<img class="icon" :src="iconImg" alt="预约失败">
		<img class="text" :src="textImg" alt="" />
		<!-- <button class="download-btn" @click="goDownload">点击下载</button> -->
		<img class="button" :src="buttonImg" alt="领取资金来源凭证" @click="$router.push('/claimVouchers')" />
		<!-- <img class="tip" :src="tipImg" alt="如需帮助请联系客服" /> -->
		<span class="tip">
			如需帮助请<span>联系客服</span><br />
			错误代码：ERR-APPT-FULL-01
		</span>
	</div>
</template>

<script>
	import iconImg from '@/assets/icon/appointmentFailed/failed_icon.png';
	import textImg from '@/assets/icon/appointmentFailed/failed_text.png';
	import buttonImg from '@/assets/icon/appointmentFailed/failed_button.jpg';
	import tipImg from '@/assets/icon/appointmentFailed/failed_tip.jpg';
	export default {
		name: "AppointmentFailed",
		data() {
			return {
				iconImg: iconImg,
				textImg: textImg,
				buttonImg: buttonImg,
				tipImg: tipImg,
			};
		},
		created() {
			this.$parent.footer('AppointmentFailed', false);
		},
		methods: {

		}
	};
</script>

<style scoped>
	.container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		/* padding: 62px 16px 24px 16px; */
		/* color: #b22222; */
		font-family: "微软雅黑", sans-serif;
		height: 100vh;
		width: 10rem;
		background: url('../../assets/icon/appointmentFailed/bg.jpg') 100% no-repeat;
		background-size: 100% 100%;
	}

	.header-title {
		position: relative;
		z-index: 1;
		width: 100%;
		text-align: center;
		font-size: 4.8vw;
		font-weight: 600;
		padding: 4vw 0;
		background: #fff;
		box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
		color: #333;
		border-bottom: 1px solid rgba(0, 0, 0, .05);
	}

	.header-title .back-icon {
		position: absolute;
		left: 4vw;
		top: 50%;
		transform: translateY(-50%);
		font-size: 5.33333vw;
		color: #333;
	}

	.icon {
		width: 4.5rem;
		margin-top: 1rem;
	}

	.text {
		width: 90%;
		margin-top: 1rem;
	}

	.button {
		width: 55%;
		margin-top: 1.5rem;
	}

	.tip {
		color: #7b7b7b;
		font-size: 18px;
		font-weight: bold;
		line-height: 1.2;
		letter-spacing: 1px;
		position: absolute;
		bottom: 2%;
	}

	.tip span {
		color: #134993;
	}
</style>